import React from "react";
import { Container, Paper, Typography, Box, Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { nomeEmpresa } from "../../../../package.json";

const useStyles = makeStyles((theme) => ({
    root: {
        height: "100vh",
        backgroundColor: theme.palette.type === "light" ? theme.palette.primary.main : "#1c1c1c",
        overflowY: "auto",
        overflowX: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),

        // Scrollbar vertical pill style with transparency
        "&::-webkit-scrollbar": {
            width: 8,
        },
        "&::-webkit-scrollbar-thumb": {
            background: "rgba(255, 255, 255, 0.35)",
            borderRadius: 100,
        },
        "&::-webkit-scrollbar-thumb:hover": {
            background: "rgba(255, 255, 255, 0.55)",
        },
        "&::-webkit-scrollbar-track": {
            background: "transparent",
        },
    },
    paper: {
        padding: theme.spacing(5),
        borderRadius: theme.neoUI?.floating.card?.borderRadius || 20,
        boxShadow: theme.neoUI?.floating.card?.boxShadow || "0 20px 60px -10px rgba(0, 0, 0, 0.15), 0 8px 24px -4px rgba(0, 0, 0, 0.1)",
        border: theme.neoUI?.floating.card?.border || "1px solid rgba(0, 0, 0, 0.04)",
        backgroundColor: "#ffffff",
        color: "#000000",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
        "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: theme.neoUI?.floating.card?.hoverShadow || "0 28px 70px -10px rgba(0, 0, 0, 0.18), 0 12px 30px -4px rgba(0, 0, 0, 0.12)",
        },
    },
    button: {
        backgroundColor: theme.palette.primary.main,
        color: "#ffffff",
        borderRadius: 10,
        padding: "10px 20px",
        fontWeight: 600,
        boxShadow: theme.neoUI?.floating.button?.boxShadow || "0 4px 12px rgba(20, 164, 92, 0.25)",
        transition: "all 0.3s ease-in-out",
        "&:hover": {
            backgroundColor: theme.palette.primary.dark,
            transform: "translateY(-2px)",
            boxShadow: theme.neoUI?.floating.button?.hoverShadow || "0 8px 20px rgba(20, 164, 92, 0.3)",
        },
    },
}));

const DataDeletion = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Container maxWidth="md">
                <Paper className={classes.paper}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                        <Typography variant="h4" component="h1" gutterBottom>
                            Instruções de Exclusão de Dados
                        </Typography>
                        <Button variant="contained" className={classes.button} component={Link} to="/login">
                            Voltar para Login
                        </Button>
                    </Box>

                    <Typography variant="body1" paragraph>
                        De acordo com as regras da Plataforma do Facebook e outras leis de privacidade (como a LGPD), você tem o direito de solicitar a exclusão dos seus dados armazenados em nossa plataforma {nomeEmpresa}.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        Como solicitar a exclusão dos seus dados
                    </Typography>

                    <Typography variant="body1" paragraph>
                        Se você deseja remover sua conta e todos os dados associados, siga os passos abaixo:
                    </Typography>

                    <Typography variant="body1" component="div">
                        <ol>
                            <li>Entre em contato com nossa equipe de suporte através do email oficial ou canal de atendimento.</li>
                            <li>Forneça as informações necessárias para identificarmos sua conta (email cadastrado ou ID da conta).</li>
                            <li>Solicite formalmente a exclusão da sua conta e dos dados associados.</li>
                            <li>Nossa equipe processará sua solicitação e confirmará a exclusão dentro do prazo legal estabelecido.</li>
                        </ol>
                    </Typography>

                    <Typography variant="body1" paragraph>
                        Alternativamente, se você utilizou o Login do Facebook:
                    </Typography>
                    <Typography variant="body1" component="div">
                        <ol>
                            <li>Aceda ao seu perfil do Facebook e vá em <strong>Configurações e privacidade &gt; Configurações</strong>.</li>
                            <li>Clique em <strong>Aplicativos e sites</strong>.</li>
                            <li>Encontre o aplicativo <strong>{nomeEmpresa}</strong> na lista.</li>
                            <li>Clique no botão <strong>Remover</strong>.</li>
                            <li>Em seguida, você poderá ver a opção de enviar uma solicitação de exclusão de dados. Clique no link para solicitar a exclusão de seus dados.</li>
                        </ol>
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        O que acontece após a exclusão?
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Após a confirmação da exclusão, todos os seus dados pessoais, histórico de conversas e configurações serão permanentemente removidos de nossos servidores, exceto aqueles que somos obrigados a manter por lei.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        Contato
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Para dúvidas relacionadas à exclusão de dados, entre em contato conosco.
                    </Typography>
                </Paper>
            </Container>
        </div>
    );
};

export default DataDeletion;
